module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"transaction":"Identificador","transaction.data":"Dados da transação","amount":"Valor","reason":"Motivo","flag":"Bandeira","credit-card-number":"Nº do cartão"},"en-US":{"transaction":"Identifier","transaction.data":"Transaction data","amount":"Amount","reason":"Reason","flag":"Flag","credit-card-number":"Card number"}}')
  delete Component.options._Ctor
}
